
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/videojocs",
      function () {
        return require("private-next-pages/corporatiu/videojocs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/videojocs"])
      });
    }
  